<template>
    <section class="files-page">

        <b-modal id="slicing-profiles-access" title="Slicing Profile Rights">
            Who could use and edit %SProfile Name%:
            <b-checkbox>First group</b-checkbox>
            <b-checkbox>Second group</b-checkbox>
            <template v-slot:modal-footer="{cancel, ok }">
                <div class="modal__footer--left">
                    <b-button variant="-ternary btn--outline" @click="cancel()">
                        Cancel
                    </b-button>
                </div>
                <div class="modal__footer--right">
                    <b-button variant="-primary" @click="ok()">
                        Save changes
                    </b-button>
                </div>
            </template>
        </b-modal>
        <b-modal id="edit-file" modal-class="modal--edit" title="Editing Tutorial Santa Duck.stl">
            <label> <span>Title</span> <input type="text" class="inp" value="Editing Tutorial Santa Duck.stl"> </label>
            <label> <span>Default slicing profiles</span> <input type="text" class="inp" value="TODO: Multiselect">
            </label> <label><span>Public sharing</span>
            <b-checkbox class="check" v-model="shareObj">Allow to display in search</b-checkbox>
        </label>
            <div v-if="shareObj">
                <label> <span>Description</span> <input type="text" class="inp" value="Editing Tutorial Santa Duck">
                </label> <label> <span>Related tags</span> <input type="text" class="inp" value="TODO: Multiselect">
            </label>
            </div>
            <template v-slot:modal-footer="{ cancel, ok }">
                <div class="modal__footer--left">
                    <b-button variant="-ternary btn--outline" @click="cancel()">
                        Cancel
                    </b-button>
                </div>
                <div class="modal__footer--right">
                    <b-button variant="-primary" @click="ok()">
                        Save
                    </b-button>
                </div>
            </template>
        </b-modal>
        <b-modal id="edit-project" modal-class="modal--edit" title="Editing First Project">
            <label> <span>Title</span> <input type="text" class="inp" value="First project"> </label>
            <div class="colorpicker colorpicker--delete colorpicker--open">
                <div></div>
            </div>
            <template v-slot:modal-footer="{ cancel, ok }">
                <div class="modal__footer--left">
                    <b-button variant="-ternary btn--outline" @click="cancel()">
                        Cancel
                    </b-button>
                </div>
                <div class="modal__footer--right">
                    <b-button variant="-primary" @click="ok()">
                        Save
                    </b-button>
                </div>
            </template>
        </b-modal>
        <b-modal id="edit-slicing-profile" modal-class="modal--edit"
                 title="Editing Tutorial Santa Duck.stl">
            <label> <span>Title</span> <input type="text" class="inp" value="Anton PVA Test"> </label> <label>
            <span>Priority</span> <input type="text" class="inp modal--edit-slicing-profile__priority"
                                         value="0"></label>
            <template v-slot:modal-footer="{ cancel, ok }">
                <div class="modal__footer--left">
                    <b-button variant="-ternary btn--outline" @click="cancel()">
                        Cancel
                    </b-button>
                </div>
                <div class="modal__footer--right">
                    <b-button variant="-primary" @click="ok()">
                        Save
                    </b-button>
                </div>
            </template>
        </b-modal>
        <b-modal id="add-files" modal-class="modal modal--add-files" title="Upload files">
            <b-form-group>
                <b-form-radio v-model="fileType" size="sm" value="single">Single file</b-form-radio>
                <b-form-radio v-model="fileType" size="sm" class="modal--add-files__project-radio"
                              value="project">Project
                </b-form-radio>
                <select v-if="fileType==='project'" class="sel sel--small">
                    <option value="value1">Create new one</option>
                    <option value="value2">Second project</option>
                </select>
            </b-form-group>
            <div class="modal--add-files__drop-area">
                <b-button variant="-primary">Choose file</b-button>
                <span>or simply drag file to this box (maximum file size 1GB)</span>
            </div>
            <div class="modal--add-files__details">
                <div class="progress progress--mini">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                         aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: 75%">
                        Tutorial Santa Duck.stl
                    </div>
                </div>
                <select class="sel sel--small">
                    <option value="value1">Simplify 3D</option>
                    <option value="value2">Move to project</option>
                </select> <select class="sel sel--small">
                <option value="value1">Ultimaker 5</option>
                <option value="value2">Move to project</option>
            </select>
                <b-checkbox>Pack it to ZIP &nbsp;</b-checkbox>
            </div>
            <template v-slot:modal-footer="{ ok }">
                <div class="modal__footer--left"></div>
                <div class="modal__footer--right">
                    <b-button variant="-primary" @click="ok()">
                        Save and go to my files
                    </b-button>
                </div>
            </template>
        </b-modal>
        <div class="top-bar">
            <div class="top-bar--left">
                <b-button @click="tabIndex=0" size="-tab" variant="-gray"
                          :class="{ 'btn--primary': tabIndex === 0 }">Files
                </b-button>
                <b-button @click="tabIndex=1" size="-tab" variant="-gray"
                          :class="{ 'btn--primary': tabIndex === 1 }">Projects
                </b-button>
                <b-button @click="tabIndex=2" size="-tab" variant="-gray"
                          :class="{ 'btn--primary': tabIndex === 2 }">Slicing profiles
                </b-button>
            </div>
            <div class="top-bar--right">
                <b-button variant="-primary" v-b-modal.add-files>Add files</b-button>
                <b-button variant="-primary" v-b-modal.modal-1>Create design</b-button>
            </div>
        </div>
        <b-tabs v-model="tabIndex">
            <b-tab class="files-page__files-tab" active>
                <b-card-text>
                    <div class="table table--hero">
                        <TableFunctions></TableFunctions>
                        <b-table :fields="fields" :items="items" sticky-header sort-icon-left>
                            <template v-slot:cell(check)="data">
                                <b-form-checkbox v-if="data.item.status!=='removed'"></b-form-checkbox>
                            </template>
                            <template v-slot:cell(id)></template>
                            <template v-slot:cell(name)="data">


                                <span :class="[{ 'text--600' : !data.item.status }, { 'text--muted' : data.item.status }, { 'text--striked' : data.item.status=='removed' }]">{{ data.item.name }} </span>
                                <b-button v-if="!data.item.status" size="-x-small" variant="-primary"
                                          v-b-modal.edit-file>Edit
                                </b-button>

                                <b-button size="-x-small" variant="-secondary">Download</b-button>
                                <b-badge v-if="data.item.badge" variant="-yellow">{{data.item.badge}}</b-badge>
                            </template>
                            <template v-slot:cell(img)="data">
                                <img v-if="!data.item.status" class="files-page__preview--small" :src="data.item.img"
                                     :alt="data.item.name"> <i v-else-if="data.item.status==='inProgress'"
                                                               class="icon icon--spinner" v-b-tooltip.hover
                                                               title="File processing..."> <i class="inner1"></i> <i
                                    class="inner2"></i> </i> <i v-else-if="data.item.status==='error'" v-b-tooltip.hover
                                                                class="icon icon--error" title="Rendering error"> </i>
                            </template>
                            <template v-slot:cell(log)="data">
                                <i class="icon icon--file icon--file--c-green"> <span>gco</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" fill-rule="evenodd"
                                         clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2">
                                        <g>
                                            <path class="file-body"
                                                  d="M14 1.635C14 .733 13.267 0 12.365 0H4.913L0 4.684v9.681C0 15.267.733 16 1.635 16h10.73c.902 0 1.635-.733 1.635-1.635V1.635z"
                                                  fill="#ebebeb"/>
                                            <path d="M4.913 0v3.069c-.043.899-.711 1.569-1.631 1.615H0L4.848.063 4.913 0z"
                                                  fill-opacity=".2"/>
                                        </g>
                                    </svg>
                                </i>
                            </template>
                            <template v-slot:cell(date)="data">
                                <p v-if="data.item.date">
                                    {{data.item.date}}
                                    <!--                                TODO: add timeago-->
                                    <span class="text--gray"> by </span> <span
                                        v-if="data.item.creator">{{data.item.creator}}</span> <span v-else>me</span>
                                </p>
                            </template>
                            <template v-slot:cell(action1)="data">
                                <b-button v-if="!data.item.status" size="-small" variant="-yellow">Repair</b-button>
                            </template>
                            <template v-slot:cell(action2)="data">
                                <b-button v-if="!data.item.status" size="-small" variant="-orange">Layout</b-button>
                            </template>
                            <template v-slot:cell(action3)="data">
                                <b-button v-if="!data.item.status" size="-small" variant="-blue">Slice</b-button>
                                <b-button v-else-if="data.item.status==='removed'" size="-small" variant="-blue">Restore
                                </b-button>
                                <b-button v-else size="-small" variant="-delete">Stop</b-button>
                            </template>
                            <template v-slot:cell(extra)="data">
                                <b-button v-if="!data.item.status" size="-small" variant="-gray" :id="data.index">...
                                </b-button>
                                <b-popover class="popover popover--applications" target="1" triggers="click"
                                           placement="bottomleft">
                                    <template v-slot:title>Applications</template>
                                    <div class="popover--applications__item">
                                        <img src="https://live-cdn-3dprinteros.azureedge.net/assets/apps/virtualfactory/ico.png"
                                             width="94" height="99" alt="Print through Industrial printers Factory">
                                        <h6>Print through Industrial printers Factory</h6>
                                    </div>
                                </b-popover>
                            </template>
                            <template v-slot:cell(delete)="data">
                                <span class="text--muted text--italic text--xsmall"
                                      v-if="data.item.status==='removed'">removed</span>
                                <b-button size="-txt" v-if="!data.item.status">
                                    <i class="icon icon--trash">
                                        <svg >
                                            <use xlink:href="#trash"></use>
                                        </svg>
                                    </i>
                                </b-button>
                            </template>
                        </b-table>
                    </div>
                </b-card-text>
            </b-tab>
            <b-tab class="files-page__projects-tab">
                <b-card-text>
                    <div class="table table--hero table--project">
                        <TableFunctions></TableFunctions>
                        <div v-b-toggle.collapse-1 class="tog tog--project top-bar">
                            <div class="top-bar--left"><i
                                    class="icon icon--file icon--file--big-number icon--file--c-white"> <span>6</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" fill-rule="evenodd"
                                     clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2">
                                    <g>
                                        <path class="file-body"
                                              d="M14 1.635C14 .733 13.267 0 12.365 0H4.913L0 4.684v9.681C0 15.267.733 16 1.635 16h10.73c.902 0 1.635-.733 1.635-1.635V1.635z"
                                              fill="#ebebeb"/>
                                        <path d="M4.913 0v3.069c-.043.899-.711 1.569-1.631 1.615H0L4.848.063 4.913 0z"
                                              fill-opacity=".2"/>
                                    </g>
                                </svg>
                            </i> <span>First Project</span> <i class="icon icon--play"></i></div>
                            <div class="top-bar--right">
                                <b-button size="-small" variant="-outline btn--white" v-b-modal.edit-project>Edit
                                </b-button>
                                <b-button size="-small" variant="-outline btn--white">Status</b-button>
                                <b-button size="-small" variant="-outline btn--white">Share</b-button>
                                <b-button size="-txt">
                                    <i class="icon icon--trash icon--trash--white">
                                        <svg >
                                        <use xlink:href="#trash"></use>
                                    </svg>
                                    </i>
                                </b-button>
                            </div>
                        </div>
                        <b-collapse id="collapse-1">
                            <b-table :fields="fields" :items="items" sort-icon-left>
                                <template v-slot:cell(check)="data">
                                    <b-form-checkbox v-if="data.item.status!=='removed'"></b-form-checkbox>
                                </template>
                                <template v-slot:cell(id)></template>
                                <template v-slot:cell(name)="data">
                                    <span :class="[{ 'text--600' : !data.item.status }, { 'text--muted' : data.item.status }, { 'text--striked' : data.item.status=='removed' }]">{{ data.item.name }} </span>
                                    <b-button v-if="!data.item.status" size="-x-small" variant="-primary"
                                              v-b-modal.edit-file>Edit
                                    </b-button>
                                    <b-button size="-x-small" variant="-gray">Download</b-button>
                                    <b-badge v-if="data.item.badge" variant="-yellow">{{data.item.badge}}</b-badge>
                                </template>
                                <template v-slot:cell(img)="data">
                                    <img v-if="!data.item.status" class="files-page__preview--small"
                                         :src="data.item.img" :alt="data.item.name"> <i
                                        v-else-if="data.item.status==='inProgress'" class="icon icon--spinner"
                                        v-b-tooltip.hover title="File processing..."> <i class="inner1"></i> <i
                                        class="inner2"></i> </i> <i v-else-if="data.item.status==='error'"
                                                                    v-b-tooltip.hover class="icon icon--error"
                                                                    title="Rendering error"> </i>
                                </template>
                                <template v-slot:cell(log)="data">
                                    <i class="icon icon--file icon--file--c-green"> <span>gco</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16"
                                             fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round"
                                             stroke-miterlimit="2">
                                            <g>
                                                <path class="file-body"
                                                      d="M14 1.635C14 .733 13.267 0 12.365 0H4.913L0 4.684v9.681C0 15.267.733 16 1.635 16h10.73c.902 0 1.635-.733 1.635-1.635V1.635z"
                                                      fill="#ebebeb"/>
                                                <path d="M4.913 0v3.069c-.043.899-.711 1.569-1.631 1.615H0L4.848.063 4.913 0z"
                                                      fill-opacity=".2"/>
                                            </g>
                                        </svg>
                                    </i>
                                </template>
                                <template v-slot:cell(date)="data">
                                    <p v-if="data.item.date">
                                        {{data.item.date}}
                                        <!--                                TODO: add timeago-->
                                        <span class="text--gray"> by </span> <span
                                            v-if="data.item.creator">{{data.item.creator}}</span> <span v-else>me</span>
                                    </p>
                                </template>
                                <template v-slot:cell(action1)="data">
                                    <b-button v-if="!data.item.status" size="-small" variant="-yellow">Repair</b-button>
                                </template>
                                <template v-slot:cell(action2)="data">
                                    <b-button v-if="!data.item.status" size="-small" variant="-orange">Layout</b-button>
                                </template>
                                <template v-slot:cell(action3)="data">
                                    <b-button v-if="!data.item.status" size="-small " variant="-blue">Slice</b-button>
                                    <b-button v-else-if="data.item.status==='removed'" size="-small"
                                              variant="-blue">Undo
                                    </b-button>
                                    <b-button v-else size="-small" variant="-delete">Stop</b-button>
                                </template>
                                <template v-slot:cell(extra)="data">
                                    <b-button v-if="!data.item.status" size="-small" variant="-gray"
                                              :id="data.index">...
                                    </b-button>
                                    <b-popover class="popover popover--applications" target="1" triggers="click"
                                               placement="bottomleft">
                                        <template v-slot:title>Applications</template>
                                        <div class="popover--applications__item">
                                            <img src="https://live-cdn-3dprinteros.azureedge.net/assets/apps/virtualfactory/ico.png"
                                                 width="94" height="99" alt="Print through Industrial printers Factory">
                                            <h6>Print through Industrial printers Factory</h6>
                                        </div>
                                    </b-popover>
                                </template>
                                <template v-slot:cell(delete)="data">
                                <span class="text--muted text--italic text--xsmall"
                                      v-if="data.item.status==='removed'">removed</span>
                                    <b-button size="-txt" v-if="!data.item.status">
                                        <i class="icon icon--trash">
                                            <svg >
                                                <use xlink:href="#trash"></use>
                                            </svg>
                                        </i>
                                    </b-button>
                                </template>
                            </b-table>
                        </b-collapse>
                        <div v-b-toggle.collapse-2 class="tog tog--project tog--blue top-bar">
                            <div class="top-bar--left"><i
                                    class="icon icon--file icon--file--big-number icon--file--c-white"> <span>2</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" fill-rule="evenodd"
                                     clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2">
                                    <g>
                                        <path class="file-body"
                                              d="M14 1.635C14 .733 13.267 0 12.365 0H4.913L0 4.684v9.681C0 15.267.733 16 1.635 16h10.73c.902 0 1.635-.733 1.635-1.635V1.635z"
                                              fill="#ebebeb"/>
                                        <path d="M4.913 0v3.069c-.043.899-.711 1.569-1.631 1.615H0L4.848.063 4.913 0z"
                                              fill-opacity=".2"/>
                                    </g>
                                </svg>
                            </i> <span>Lorem Ipsum project</span> <i class="icon icon--play"></i></div>
                            <div class="top-bar--right">
                                <b-button size="-txt" variant="-white">Edit</b-button>
                                <b-button size="-txt" variant="-white">Status</b-button>
                                <b-button size="-txt" variant="-white">Share</b-button>
                                <b-button size="-txt">
                                    <i class="icon icon--trash icon--trash--white">
                                        <svg >
                                            <use xlink:href="#trash"></use>
                                        </svg>
                                    </i>
                                </b-button>
                            </div>
                        </div>
                        <b-collapse id="collapse-2">
                            <b-table :fields="fields" :items="items" sort-icon-left>
                                <template v-slot:cell(check)="data">
                                    <b-form-checkbox v-if="data.item.status!=='removed'"></b-form-checkbox>
                                </template>
                                <template v-slot:cell(id)></template>
                                <template v-slot:cell(name)="data">
                                    <span :class="[{ 'text--600' : !data.item.status }, { 'text--muted' : data.item.status }, { 'text--striked' : data.item.status=='removed' }]">{{ data.item.name }} </span>
                                    <b-button v-if="!data.item.status" size="-x-small" variant="-primary"
                                              v-b-modal.edit-file>Edit
                                    </b-button>
                                    <b-button size="-x-small" variant="-gray">Download</b-button>
                                    <b-badge v-if="data.item.badge" variant="-yellow">{{data.item.badge}}</b-badge>
                                </template>
                                <template v-slot:cell(img)="data">
                                    <img v-if="!data.item.status" class="files-page__preview--small"
                                         :src="data.item.img" :alt="data.item.name"> <i
                                        v-else-if="data.item.status==='inProgress'" class="icon icon--spinner"
                                        v-b-tooltip.hover title="File processing..."> <i class="inner1"></i> <i
                                        class="inner2"></i> </i> <i v-else-if="data.item.status==='error'"
                                                                    v-b-tooltip.hover class="icon icon--error"
                                                                    title="Rendering error"> </i>
                                </template>
                                <template v-slot:cell(log)="data">
                                    <i class="icon icon--file icon--file--c-green"> <span>gco</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16"
                                             fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round"
                                             stroke-miterlimit="2">
                                            <g>
                                                <path class="file-body"
                                                      d="M14 1.635C14 .733 13.267 0 12.365 0H4.913L0 4.684v9.681C0 15.267.733 16 1.635 16h10.73c.902 0 1.635-.733 1.635-1.635V1.635z"
                                                      fill="#ebebeb"/>
                                                <path d="M4.913 0v3.069c-.043.899-.711 1.569-1.631 1.615H0L4.848.063 4.913 0z"
                                                      fill-opacity=".2"/>
                                            </g>
                                        </svg>
                                    </i>
                                </template>
                                <template v-slot:cell(date)="data">
                                    <p v-if="data.item.date">
                                        {{data.item.date}}
                                        <!--                                TODO: add timeago-->
                                        <span class="text--gray"> by </span> <span
                                            v-if="data.item.creator">{{data.item.creator}}</span> <span v-else>me</span>
                                    </p>
                                </template>
                                <template v-slot:cell(action1)="data">
                                    <b-button v-if="!data.item.status" size="-small" variant="-yellow">Repair</b-button>
                                </template>
                                <template v-slot:cell(action2)="data">
                                    <b-button v-if="!data.item.status" size="-small" variant="-orange">Layout</b-button>
                                </template>
                                <template v-slot:cell(action3)="data">
                                    <b-button v-if="!data.item.status" size="-small" variant="-blue">Slice</b-button>
                                    <b-button v-else-if="data.item.status==='removed'" size="-small"
                                              variant="-blue">Undo
                                    </b-button>
                                    <b-button v-else size="-small" variant="-delete">Stop</b-button>
                                </template>
                                <template v-slot:cell(extra)="data">
                                    <b-button v-if="!data.item.status" size="-small" variant="-gray"
                                              :id="data.index">...
                                    </b-button>
                                    <b-popover class="popover popover--applications" target="1" triggers="click"
                                               placement="bottomleft">
                                        <template v-slot:title>Applications</template>
                                        <div class="popover--applications__item">
                                            <img src="https://live-cdn-3dprinteros.azureedge.net/assets/apps/virtualfactory/ico.png"
                                                 width="94" height="99" alt="Print through Industrial printers Factory">
                                            <h6>Print through Industrial printers Factory</h6>
                                        </div>
                                    </b-popover>
                                </template>
                                <template v-slot:cell(delete)="data">
                                <span class="text--muted text--italic text--xsmall"
                                      v-if="data.item.status==='removed'">removed</span>
                                    <b-button size="-txt" v-if="!data.item.status">
                                        <i class="icon icon--trash">
                                            <svg >
                                                <use xlink:href="#trash"></use>
                                            </svg>
                                        </i>
                                    </b-button>
                                </template>
                            </b-table>
                        </b-collapse>
                    </div>
                </b-card-text>
            </b-tab>
            <b-tab class="files-page__slicing-profiles-tab">
                <div class="table table--hero table--slicing-profiles">
                    <b-table :fields="slicingFields" :items="slicingItems" sort-icon-left>
                        <template v-slot:cell(visible)="data">
                            <b-form-checkbox v-model="data.item.visible" switch></b-form-checkbox>
                        </template>
                        <template v-slot:cell(name)="data">
                            <span>{{ data.item.name }} </span>
                            <b-button v-if="!data.item.status" size="-x-small" variant="-primary"
                                      v-b-modal.edit-slicing-profile>Edit
                            </b-button>
                        </template>
                        <template v-slot:cell(action1)="data">
                            <b-button size="-small" variant="-secondary" v-b-modal.slicing-profiles-access>Access
                            </b-button>
                        </template>
                        <template v-slot:cell(action2)="data">
                            <b-button size="-small" variant="-primary">Reslice</b-button>
                        </template>
                        <template v-slot:cell(delete)="data">
                            <b-button size="-txt">
                                <i class="icon icon--trash">
                                    <svg >
                                        <use xlink:href="#trash"></use>
                                    </svg>
                                </i>
                            </b-button>
                        </template>
                    </b-table>
                </div>
            </b-tab>
        </b-tabs>
    </section>
</template>

<script>
    import TableFunctions from '@/components/TableFunctions.vue';

    export default {
        name: "Files",
        components: {
            TableFunctions
        },
        data() {
            return {
                shareObj: false,
                tabIndex: 0,
                fileType: 'single',
                fields: [
                    {
                        key: 'check',
                        label: '',
                        class: 'check'
                    },
                    {
                        key: 'img',
                        label: '',
                        class: 'img'
                    },
                    {
                        key: 'name',
                        sortable: true,
                        class: 'name'
                    },
                    {
                        key: 'log',
                        class: 'log',
                        label: 'Format',
                    },
                    {
                        key: 'cost',
                        sortable: true,
                    },
                    {
                        key: 'size',
                        label: 'Size',
                        sortable: true,
                    },
                    {
                        key: 'date',
                        label: 'Created',
                        sortable: true,
                    },
                    {
                        key: 'action1',
                        label: '',
                        class: 'action1',
                    },
                    {
                        key: 'action2',
                        label: '',
                        class: 'action2',
                    },
                    {
                        key: 'action3',
                        label: '',
                        class: 'action3',
                    },
                    {
                        key: 'extra',
                        label: '',
                        class: 'extra',
                    },
                    {
                        key: 'delete',
                        label: '',
                        class: 'extra',
                    },
                ],
                items: [
                    {
                        id: '666',
                        img: 'https://live3dprinteros.blob.core.windows.net/render/7d8ff22371193294d02940385841d4e59a219c8bcd2ec4a4254feb5bda24a1f3.png.square.png',
                        name: 'Tutorial Santa Duck.stl',
                        creator: 'someone',
                        badge: 'First Printer',
                        log: '.stl',
                        size: '1.67mb',
                        cost: '$23',
                        date: '10 min ago'
                    },
                    {
                        id: '666',
                        img: 'https://live3dprinteros.blob.core.windows.net/render/7d8ff22371193294d02940385841d4e59a219c8bcd2ec4a4254feb5bda24a1f3.png.square.png',
                        name: 'Second Duck.stl',
                        badge: 'Miracle Grue',
                        creator: 'someone',
                        log: '.stl',
                        size: '1.67mb',
                        cost: '$23',
                        date: '10 min ago'
                    },
                    {
                        id: '666',
                        img: 'https://live3dprinteros.blob.core.windows.net/render/7d8ff22371193294d02940385841d4e59a219c8bcd2ec4a4254feb5bda24a1f3.png.square.png',
                        name: 'Random file.stl',
                        creator: 'someone',
                        log: '.stl',
                        badge: 'Some more data',
                        size: '1.67mb',
                        cost: '$23',
                        date: '10 min ago'
                    },
                    {
                        id: '666',
                        img: 'https://live3dprinteros.blob.core.windows.net/render/7d8ff22371193294d02940385841d4e59a219c8bcd2ec4a4254feb5bda24a1f3.png.square.png',
                        name: 'Nope.stl',
                        log: '.stl',
                        status: 'inProgress',
                    },
                    {
                        id: '666',
                        img: 'https://live3dprinteros.blob.core.windows.net/render/7d8ff22371193294d02940385841d4e59a219c8bcd2ec4a4254feb5bda24a1f3.png.square.png',
                        name: 'File with error.stl',
                        log: '.stl',
                        status: 'error',
                    },
                    {
                        id: '666',
                        name: 'Recently removed file.stl',
                        status: 'removed',
                        badge: 'Some more data',
                        size: '4.1mb',
                        cost: '$23',
                        date: '10 min ago'
                    },
                ],
                slicingFields: [
                    {
                        key: 'visible',
                        class: 'visible',
                        label: 'Show'
                    },
                    {
                        key: 'printer',
                        class: 'printer',
                        sortable: true
                    },
                    {
                        key: 'name',
                        class: 'name',
                        sortable: true
                    },
                    {
                        key: 'slicer',
                        class: 'slicer'
                    },
                    {
                        key: 'created',
                        class: 'created',
                        sortable: true
                    },
                    {
                        key: 'priority',
                        class: 'priority'
                    },
                    {
                        key: 'action1',
                        class: 'action1',
                        label: ''
                    },
                    {
                        key: 'action2',
                        class: 'action2',
                        label: ''
                    },
                    {
                        key: 'delete',
                        class: 'delete',
                        label: ''
                    },

                ],
                slicingItems: [
                    {
                        id: '666',
                        visible: true,
                        printer: 'DREMEL 3D 45',
                        name: 'Anton PVA Test',
                        creator: 'someone',
                        slicer: 'Slicer 3',
                        priority: 0,
                        created: '10 min ago by Alex Strykhotskyi',
                    },
                    {
                        id: '666',
                        visible: true,
                        printer: 'MB 5th Replicator Z18',
                        name: 'PLA (Verbatim) - Standard (mkozlov)',
                        creator: 'someone',
                        slicer: 'Slicer for Makerbots',
                        priority: 0,
                        created: '2 months ago by Someone Else',
                    },
                ],
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../scss/theme";

    .files-page {
        &__projects-tab {
            margin-top: 12px;

            .tog {
                background-color: $c-delete;
                padding: 0 8px;
                font-weight: 600;
                font-size: 16px;

                .icon--file {
                    width: 28px;
                    top: -7px;
                    transform: scale(.9);

                    span {
                        color: $c-delete;
                    }
                }

                .inp {
                    position: relative;
                    left: 3px;
                }

                &--blue {
                    background-color: $c-blue;

                    .icon--file {
                        span {
                            color: $c-blue;
                        }
                    }
                }

            }

            .collapse {
                padding-bottom: 16px;
            }
        }

        &__preview--small {
            position: relative;
            width: 28px;
            height: 28px;
            border-radius: 50%;

            &:before {
                content: '';
                position: absolute;
                height: 100%;
                width: 100%;
                background: #daf7fb;
            }
        }

        .nav-tabs {
            display: none;
        }

        .table {
            .name {
                overflow: hidden;

                span.active {
                    font-weight: 600;
                }

                .btn, .badge {
                    position: relative;
                    right: -36px;
                    opacity: 0;
                    margin-left: 6px;
                    transition: .2s all;
                }

                .btn {
                    top: -1px;
                    margin-right: 4px;
                    transition: .4s all;
                }
            }

            tr {
                height: 48px;
                transition: .4s all;

                &:hover {
                    .name {
                        .btn, .badge {
                            right: 0;
                            opacity: 1;
                            transition: .4s all;
                        }

                    }
                }
            }

            .action1, .action2, .action3, .extra, .delete {
                padding-right: 4px;
                width: 1%;
                white-space: nowrap;
            }
            .check {
                width: 60px;
                padding: 4px 0 4px 12px;
            }

            .visible {
                width: 90px;
                padding: 12px 0 12px 16px;
            }

            .log, .printer, .slicer, .created, .priority {
                padding-right: 36px;
                width: 1%;
                white-space: nowrap;
            }

            .priority {
                padding-right: 15%;
            }
        }

        .tog {
            margin-top: 12px;
        }
    }
</style>
